// pages/NavBar.js
import React from "react";
import {Link} from "react-router-dom";

function NavBar() {
  return (
    <div>
      <nav style={styles.navbar}>
        <ul style={styles.navList}>
          <li style={styles.navItem}>
            <Link to="/" style={styles.navLink}>
              NavBar
            </Link>
          </li>
          <li style={styles.navItem}>
            <Link to="/TermsOfService" style={styles.navLink}>
              Condiciones de Servicio
            </Link>
          </li>
          <li style={styles.navItem}>
            <Link to="/PrivacyPolicy" style={styles.navLink}>
              Política de Privacidad
            </Link>
          </li>
          <li style={styles.navItem}>
            <Link to="/Support" style={styles.navLink}>
              Asistencia
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}

const styles = {
  navbar: {
    backgroundColor: "#333",
    padding: "1rem",
  },
  navList: {
    listStyleType: "none",
    display: "flex",
    justifyContent: "space-around",
    margin: 0,
    padding: 0,
  },
  navItem: {
    margin: "0 1rem",
  },
  navLink: {
    color: "white",
    textDecoration: "none",
    fontSize: "1.2rem",
  },
};

export default NavBar;
